import type { ReportJobTypes } from '@weft/types';
import { REPORT_JOB_TYPES } from '@weft/types';
import { raiseUnreachable } from '@weft/utils';
import { TriggerAnonymousCustomersReportJobForm } from '../reports-page-components/trigger-report-job-dialog/report-job-forms/TriggerAnonymousCustomersReportJobForm';
import { TriggerCommitmentUsageReportJobForm } from '../reports-page-components/trigger-report-job-dialog/report-job-forms/TriggerCommitmentUsageReportJobForm';
import { TriggerContractsReportJobForm } from '../reports-page-components/trigger-report-job-dialog/report-job-forms/TriggerContractsReportJobForm';
import { TriggerMonthlyClosureReportJobForm } from '../reports-page-components/trigger-report-job-dialog/report-job-forms/TriggerMonthlyClosureReportJobForm';
import { TriggerProductsUsageReportJobForm } from '../reports-page-components/trigger-report-job-dialog/report-job-forms/TriggerProductsUsageReportJobFrom';
import { TriggerUnchargedUsageReportJobForm } from '../reports-page-components/trigger-report-job-dialog/report-job-forms/TriggerUnchargedUsageReportJobForm';
import type { TriggerReportJobFormProps } from '../reports-page-components/trigger-report-job-dialog/TriggerReportJobDialog';
 
export function getSelectedReportJobForm(reportJobType: ReportJobTypes, props: TriggerReportJobFormProps): React.ReactElement<TriggerReportJobFormProps> {
  switch (reportJobType) {
    case REPORT_JOB_TYPES.CommitmentUsage:
      return <TriggerCommitmentUsageReportJobForm {...props} />;
    case REPORT_JOB_TYPES.UnchargedUsage:
      return <TriggerUnchargedUsageReportJobForm {...props}/>;
    case REPORT_JOB_TYPES.ProductsUsage:
      return <TriggerProductsUsageReportJobForm {...props} />;
    case REPORT_JOB_TYPES.Contracts:
      return <TriggerContractsReportJobForm {...props} />;
    case REPORT_JOB_TYPES.AnonymousCustomers:
      return <TriggerAnonymousCustomersReportJobForm {...props} />;
    case REPORT_JOB_TYPES.MonthlyClosure: 
      return <TriggerMonthlyClosureReportJobForm {...props} />;
    case REPORT_JOB_TYPES.CustomerRevenue:
      return <></>;
    default:
      return raiseUnreachable(reportJobType);
  }
}